<div class="lum-c-purchase-order-shipments-table">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading$ | async"
    [classes]="'loading'"
  ></div>

  <table
    *ngIf="(shipments$ | async)?.length; else empty"
    class="lum-table lum-table--classic striped"
  >
    <thead>
      <tr>
        <th>Reference&nbsp;#</th>
        <th>Order&nbsp;#</th>
        <th>Shipment Date</th>
        <th>Amount</th>
        <th>Shipment Status</th>
        <th>Warehouse</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let shipment of shipments$ | async; trackBy: trackById">
        <td>
          <a [routerLink]="['/orders/shipments', shipment?.id]">
            {{ shipment?.referenceNumber }}
          </a>
        </td>
        <td>
          <ng-container
            *ngFor="
              let item of shipment?.shipmentItems
                | uniqueBy: 'supplierPurchaseOrderId'
            "
          >
            <a [routerLink]="['/orders/', item?.supplierPurchaseOrderId]">
              <mat-chip class="lum-chip mr-1" [disableRipple]="true">{{
                item?.supplierPurchaseOrderId
              }}</mat-chip>
            </a>
          </ng-container>
        </td>
        <td>{{ shipment?.shippingDate | date: 'mediumDate' }}</td>
        <td>{{ shipment?.totalShippingCost | currency }}</td>
        <td>{{ shipment?.shipmentStatus?.name }}</td>
        <td>{{ shipment?.warehouse?.locationName }}</td>
        <td class="lum-c-purchase-order-shipments-table__actions flex justify-end">
          <button class="btn" type="button" [matMenuTriggerFor]="menu">
            <i class="flaticon-more"></i>
          </button>
        </td>
        <mat-menu #menu="matMenu">
          <a mat-menu-item [routerLink]="['/orders/shipments', shipment?.id]">
            View
          </a>
          <button mat-menu-item (click)="onEdit(shipment)">Edit</button>
          <button mat-menu-item (click)="onConfirmDelete(shipment.id)">
            Delete
          </button>
        </mat-menu>
      </tr>
    </tbody>
  </table>
  <ng-template #empty>
    <lum-ui-empty-page
      class="mt-8"
      title="There are no shipments to display"
    ></lum-ui-empty-page>
  </ng-template>

  <mat-paginator
    class="lum-paging lum-paging--dodge-back-to-top lum-paging--sticky"
    [length]="pagination?.total || 0"
    [pageSize]="pagination?.per_page || paginationConfig.perPage"
    [pageSizeOptions]="paginationConfig.pageSizeOptions"
    [pageIndex]="(pagination?.current_page || 1) - 1"
    (page)="onPaginationEvent($event)"
    aria-label="Select page"
  ></mat-paginator>
</div>
